<template>
  <div class="rank">
    <el-button
      class="export_btn"
      type="primary"
      icon="el-icon-download"
      size="small"
      @click="onExport"
      >导出</el-button
    >
    <el-tabs v-model="activeName">
      <el-tab-pane label="团队排名" name="1">
        <el-table class="rank_list" :data="teamRankList">
          <el-table-column type="index" label="排名" width="100" align="center">
            <template slot-scope="scope">
              <img
                src="@/assets/images/icons/icon_first.png"
                alt
                v-if="scope.$index + 1 == 1"
              />
              <img
                src="@/assets/images/icons/icon_second.png"
                alt
                v-if="scope.$index + 1 == 2"
              />
              <img
                src="@/assets/images/icons/icon_third.png"
                alt
                v-if="scope.$index + 1 == 3"
              />
              <span v-if="scope.$index + 1 > 3">{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="teamIcon"
            label="团队头像"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 44px; height: 44px"
                :src="scope.row.teamIcon"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="teamName"
            label="团队名称"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="captainName"
            label="队长"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="score"
            label="团队总分"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.score ? Number(scope.row.score.toFixed(2)) : 0 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="组建日期"
            :formatter="formatter"
            align="center"
          >
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="个人排名" name="2">
        <el-table class="rank_list" :data="rankList">
          <el-table-column type="index" label="排名" width="100" align="center">
            <template slot-scope="scope">
              <img
                src="@/assets/images/icons/icon_first.png"
                alt
                v-if="scope.$index + 1 == 1"
              />
              <img
                src="@/assets/images/icons/icon_second.png"
                alt
                v-if="scope.$index + 1 == 2"
              />
              <img
                src="@/assets/images/icons/icon_third.png"
                alt
                v-if="scope.$index + 1 == 3"
              />
              <span v-if="scope.$index + 1 > 3">{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sno" label="学号" width="150" align="center">
          </el-table-column>
          <el-table-column
            prop="avatar"
            label="头像"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 44px; height: 44px"
                :src="
                  scope.row.avatar ||
                  require('@/assets/images/icons/icon_me.png')
                "
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="nickName"
            label="姓名"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="sex"
            label="性别"
            :formatter="sexFormatter"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="teamName" label="所属团队" align="center">
            <template slot-scope="scope">
              {{ scope.row.teamName || "无" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="postName"
            label="岗位名称"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.postName || "无" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="score"
            label="个人总分"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.score ? Number(scope.row.score.toFixed(2)) : 0 }}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { teamRanking, personalRanking } from "@/api/evaluation";
import { formatDate } from "@/utils/index";
export default {
  data() {
    return {
      activeName: "1",
      rankList: [],
      teamRankList: [],
    };
  },
  created() {
    this.getTeamRanking();
    this.getPersonalRanking();
  },
  methods: {
    // 团队排行榜
    getTeamRanking() {
      teamRanking(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.teamRankList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 个人排行榜
    getPersonalRanking() {
      personalRanking(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.rankList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 格式化时间
    formatter(row) {
      return formatDate(row.createTime, "YYYY-MM-DD HH:mm:ss");
    },
    // 性别
    sexFormatter(row) {
      if (row.sex == "MAN") return "男";
      else if (row.sex == "WOMAN") return "女";
      else return "未知";
    },
    // 导出
    onExport() {
      let token = localStorage.getItem("token");
      if (this.activeName == "1") {
        window.open(
          `${process.env.VUE_APP_API_DOMAIN}/app/teacher/statistics/${this.$route.query.id}/team/export?Authorization=${token}`
        );
      } else {
        window.open(
          `${process.env.VUE_APP_API_DOMAIN}/app/teacher/statistics/${this.$route.query.id}/user/export?Authorization=${token}`
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.rank {
  position: relative;
  padding: 20px 33px;
  background-color: rgb(255, 255, 255);

  .export_btn {
    position: absolute;
    top: 22px;
    right: 33px;
    z-index: 999;
  }

  ::v-deep .rank_list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }

    .rank_num {
      display: inline-block;
      width: 22px;
      height: 22px;
      background: #f0f2f5;
      border-radius: 50%;
    }
  }
}
</style>